import React from 'react'

const Heading = () => {
  return (
    <div
        className='text-center mb-12'
        data-aos='fade-up'
        data-aos-easing='ease-in'
      >
        <h1 className='text-4xl font-semibold text-brandColor'>
          Our daily dishes
        </h1>
        <p className='text-2xl mt-4'>
          Check out recomended dishes of your choice
        </p>
      </div>
  )
}

export default Heading